export enum ISystemFieldOptionEnum {
  Required = 'Required',
  Optional = 'Optional',
}
